import React, { useLayoutEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { startFavoritedResults } from '../firebase/venues'
import { makeFavoritesUrl } from '../components/helpers'
import { getIsFetching, setIsFetching, setSearchResults } from '../store/search'
import { getUser } from '../store/user'

import RequireUser from '../components/RequireUser'
import SearchVenues from '../components/SearchVenues'
import Loading from '../components/Loading'

const PageFavoriteVenues = () => {
  const dispatch = useDispatch()
  const isFetching = useSelector(getIsFetching)
  const user = useSelector(getUser)

  useLayoutEffect(() => {
    startFavoritedResults({
      setFetching(value) {
        dispatch(setIsFetching(value))
      },
      setSearchResults(results) {
        dispatch(setSearchResults(results))
      },
      user
    })
  }, [])

  if (isFetching) {
    return <Loading />
  }

  return (
    <SearchVenues
      defaultTitle="Favorite Venues"
      noResultsMessage='No favorited venues found'
      makeUrl={makeFavoritesUrl}
    />
  )
}

export default () => (
  <RequireUser>
    <PageFavoriteVenues />
  </RequireUser>
)
